import App from '@/models/App'

export default class TrafficShipComment extends App {
    static get entity() {
        return 'TrafficShipComments'
    }
    static all() {
        return this.query().orderBy('createdAt', 'desc').get()
    }
    static fields() {
        return {
            id: this.attr(''),
            userId: this.attr(''),
            parentType: this.attr(''),
            parentId: this.attr(''),
            comment: this.attr(''),
            user: this.attr({}),
            isMine: this.attr(false),
            createdAt: this.attr(''),
        }
    }
    static apiConfig = {
        actions: {
            fetch(trafficShipId, params) {
                return this.get(`traffic/ships/${trafficShipId}/comments`, {
                    params: App.get(params),
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.apiURL(),
                })
            },
            create(trafficShipId, params) {
                return this.post(
                    `/traffic/ships/${trafficShipId}/comments`,
                    App.post(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            update(trafficShipId, trafficCommentId, params) {
                return this.patch(
                    `/traffic/ships/${trafficShipId}/comments/${trafficCommentId}`,
                    App.patch(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            destroy(trafficShipId, trafficCommentId) {
                return this.delete(
                    `traffic/ships/${trafficShipId}/comments/${trafficCommentId}`,
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        delete: trafficCommentId,
                        baseURL: App.apiURL(),
                    }
                )
            },
        },
    }
}
